import { ic, sized } from '@/components/Icons';
import { useI18n } from '@/i18n';

export interface BannerProps {
  open: boolean;
  deadline: string;
  /** True when nothing in the user's scope is pending. */
  hidden?: boolean;
}

/** La franja de la ventana de actualización.
 *
 *  Antes desaparecía del todo cuando la ventana estaba abierta y el socio
 *  ya lo tenía todo completo: cerrada salía franja, abierta no. Vitalino
 *  lo señaló en la prueba 2.2 y tenía razón en que confunde — la fecha de
 *  cierre sigue importando aunque no quede nada rojo, porque hasta ese día
 *  se puede corregir.
 *
 *  Así que siempre hay franja; lo que cambia es el tono. Naranja mientras
 *  falte algo, verde discreto cuando está todo, gris al cerrar. */
export function Banner({ open, deadline, hidden }: BannerProps) {
  const { lang, t } = useI18n();
  const completo = open && hidden;

  const dateStr = new Date(deadline).toLocaleDateString(lang === 'es' ? 'es-MX' : 'en-US', {
    day: 'numeric', month: 'long', year: 'numeric',
  });

  return (
    <div
      style={{
        background: !open ? '#3E4756'
          : completo ? '#1E7A4B'
          : 'linear-gradient(90deg, #F26522 0%, #FF8345 100%)',
        color: '#fff', padding: '10px 24px', fontSize: 13, fontWeight: 500,
        display: 'flex', alignItems: 'center', gap: 10,
      }}
    >
      {sized(!open ? ic.lock : completo ? ic.check : ic.bell, 15)}
      <span>
        {t(open ? 'window.open_banner' : 'window.closed_banner', { date: dateStr })}
        {completo ? (lang === 'es' ? ' · Tus datos están completos' : ' · Your data is complete') : null}
      </span>
    </div>
  );
}
